<template>
  <div class="pdfbox">
    <iframe
          allowfullscreen
          id="aliyunPreview"
          frameborder="0"
          :src="playUrl"
        ></iframe>
  </div>
</template>

<script>
  import {getCookie} from '../../untils/common.js'
  export default{
    data(){
      return {
        playUrl :''
      }
    },
    mounted() {
      this.playUrl = getCookie('pdfurl');
    },
    methods:{

    },
    created() {

    }
  }
</script>

<style>
  .pdfbox{
    width: 100vw;
    height: 100vh;
  }
  .pdfbox iframe{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PdfShow/PdfShow.vue